import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Typography,
  Stepper,
  Step,
  StepLabel,
  IconButton,
  FormControlLabel,
} from '@mui/material';
import { Upload, Close } from '@mui/icons-material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useDispatch, useSelector } from 'react-redux';
import MediaFilesDropzone from './MediaFilesDropzone';
import useSequentialVideoUpload from '../hooks/useSequentialVideoUpload';
import useRevisionActions from '../useRevisionActions';
import CustomVideoLinearProgress from '../../../components/CustomVideoLinearProgress';
import { updateState } from '../../../redux/commonSlice';
import CustomButton from '../../../components/CustomButton';
import BrandboxOptions from '../../brandbox/components/BrandboxOptions';
import { useNavigate } from 'react-router-dom';
import UploadIcon from '@mui/icons-material/Upload';
import useOrganisationProjectActions from '../../events/useOrganisationProjectActions';
import { generateDarkColor } from '../../../utils/commonServices';
import RevisionLogNote from "./RevisionLogNote";
import CircleIcon from '@mui/icons-material/Circle';

const UploadVideoChecklist = () => {
  const [videoFile, setVideoFile] = useState(null);
  const [checkedItems, setCheckedItems] = useState({});
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  const [isVertical, setIsVertical] = useState(false);
   const projectReducer = useSelector((state) => state.projectReducer);
   const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
   const commonReducer = useSelector((state) => state.root.commonReducer);
   const [uploadedNotes , setUploadedNotes] = useState (projectReducer?.uploaded_event_notes)
   const {getEditingCyclesList} = useRevisionActions()
   const {getProjectDetails} = useOrganisationProjectActions()
   const [onProceedClick, setOnProceedClick] = useState(false)
   const [viewBrandbox, setViewBrandbox] = useState(false)
     const [expanded, setExpanded] = useState('');
     const navigate = useNavigate()
     const [checklistChecked, setChecklistChecked] = useState(false);
   const dispatch = useDispatch()
       const { files, 
           setFiles,
           progress, 
           uploadStatus,
           setUploadStatus, 
           setProgress,
           isLoading,
           requestController, 
           setRequestController,
           stopUpload, 
           stopList ,
           enableFileUpload,
           setEnableFileUpload} = useSequentialVideoUpload(reviewEventReducer?.editing_cycle_id , false, uploadedNotes,  ()=>afterUploadCallback()) 

           const afterUploadCallback =()=>{
            // getAllEventNotes({event_id: commonReducer?.production_event_id}, dispatch) api call
            getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
            getProjectDetails({id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
            // dispatch(updateState({can_upload:false}))
          }
        

  const stepList = [
  "Title was created.",
  "Used branding guidelines fonts, logos, colors etc" ,
   "All favorited media was included" ,
    "Everything is spelled correctly",
    "The video is the appropriate length requested by the client" ,
    "Color corrected",
    "Audio Level is appropriate" ,
     "Did you tell a story? Beginning, middle and End",
     "All notes are addressed and NOT ignored (marked completed)",
     "File is exported with appropriate name" 
   
  ];


  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      setVideoFile(URL.createObjectURL(file));
    } else {
      alert('Please select a valid video file.');
    }
  };

  const handleRemoveVideo = () => {
    setVideoFile(null);
    setCheckedItems({}); // Reset checkboxes when video is removed
    setOnProceedClick(false)
  };

  const handleCheckboxChange = (index) => {
    setCheckedItems((prev) => {
      const updated = { ...prev, [index]: !prev[index] };
      return updated;
    });
  };

  const allChecked = stepList.every((_, index) => checkedItems[index]);

  const handleProceed = () => {
    if (allChecked || checklistChecked) {
      console.log('Proceeding with API call...');
      setOnProceedClick(true)
      // Call your API function here
    }
  };


  useEffect(() => {
    const videoElement = videoRef?.current;

    const handleVideoLoaded = () => {
      const videoWidth = videoElement?.videoWidth;
      const videoHeight = videoElement?.videoHeight;
      setIsVertical(videoHeight > videoWidth);
    };

    // Add event listener to handle video metadata loading
    videoElement?.addEventListener('loadedmetadata', handleVideoLoaded);

    return () => {
      videoElement?.removeEventListener('loadedmetadata', handleVideoLoaded);
    };
  }, [videoFile]);

  // console.log((reviewEventReducer?.editing_cycles_list[reviewEventReducer?.editing_cycles_list?.length - 1]?.version == 1 && reviewEventReducer?.internal_revisions_list?.length == 0 ), 'condition 1 value')

  // console.log((reviewEventReducer?.editing_cycles_list[reviewEventReducer?.editing_cycles_list?.length - 1]?.version == 1 && reviewEventReducer?.current_internal_revision?.version == 1 ), 'condition 2 value')

  // console.log((!reviewEventReducer?.selected_video_logs_list) , 'condition 3 value')

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        // maxWidth: '800px',
        // margin: '0 auto',
        height: '93.5%',
        // border: '1px solid #ccc',
        padding: 2,
        backgroundColor:'#ffffff88',
        boxShadow:'0px 5px 15px #00000029', 
        borderRadius:'10px',
        mt:1
      }}
    >
      {/* Horizontal Stepper */}
      {/* <Stepper activeStep={allChecked ? stepList.length : Object.values(checkedItems).filter(Boolean).length} sx={{ marginBottom: 2 }}>
        {stepList.map((_, index) => (
          <Step key={index} completed={checkedItems[index]}>
            <StepLabel />
          </Step>
        ))}
      </Stepper> */}

     {<Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        //   height: '500px',
          gap: 2,
          height:'100%'
        }}
      >
        {/* Left Side: Video Player or Placeholder */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            // alignItems: 'center',
            padding: 1,
            // border: '1px solid #ddd',
            borderRadius: 1,
            height:'100%',
           
          }}
        >
        <Box sx={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>
        <Box  gap={{xs:0,md:1}} sx={{display:'flex', flexDirection:'column',  paddingTop:1, paddingBottom:2 }}>
           <Typography sx={{fontSize:{xs:'13px',sm:'14px',md:'14px',lg:'16px',xl:'20px'}, fontWeight:600, letterSpacing:0, fontFamily:'Rubik'}}>{`${projectReducer?.project_details?.name}`}</Typography>
           <Typography sx={{fontSize:{xs:'11px',md:'12px',lg:'13px',xl:'17px'}, display:'inline', textDecoration:'none', width:'100%', fontFamily:'Rubik', letterSpacing:'-0.05px'}}>{`${projectReducer?.project_details?.event_type?.name}`}</Typography>  
        </Box>
                        <Button 
                           variant="text"
                             color='secondary'
                           onClick={()=> navigate('/brandbox')}
                           sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"},  fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                         >
                           View Brand Guidelines
                       </Button> 
        </Box>
          {videoFile ? (
            <>
            <Box sx={{ width: '100%', position: 'relative', height:'75%', maxHeight:'80%' , display:'flex', justifyContent:'center'}}>
              {/* <Typography variant="h6">Selected Video:</Typography> */}
              <Box  ref={containerRef} sx={{width:'100%', height:'100%', display:'flex', justifyContent:'center', px:1, backgroundColor:'black', borderRadius:'5px'}}>
              <video
              ref={videoRef}
                src={videoFile}
                controls
                style={{  backgroundColor:'black', objectFit:'contain',  width: isVertical ? 'auto' : '100%',
                    height: isVertical ? '100%' : 'auto' }}
              />
              </Box>
              <IconButton
                aria-label="remove video"
                onClick={handleRemoveVideo}
                sx={{ position: 'absolute', top:-40 , right: -10}}
              >
                <Close />
              </IconButton>
          
            </Box>
               <Typography sx={{mt: 2, fontSize: '16px', fontWeight: 800}} >{uploadStatus[0]?.message}</Typography>
               <CustomVideoLinearProgress
                progress={progress}
                status={uploadStatus[0]}
                stopUpload={() => stopUpload(0)}
                fontSize = {18}
                bar = {12}
               /> 
            </>
          ) : (
            <Box sx={{height:'100%', width:'100%',  display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
               <CloudUploadOutlinedIcon sx={{fontSize:'200px', color:'#cccccc'}}/>
            <Typography variant="h6" color="textSecondary" textAlign="center">
              Please upload a video to preview it here.
            </Typography>
            </Box>
          )}
        </Box>

        {/* Right Side: Checklist */}
        <Box
          sx={{
            width: '35%',
            display: 'flex',
            flexDirection: 'column',
            padding: 1,
            // border: '1px solid #ddd',
            borderRadius: 1,
            // overflowY: 'auto',
            height:'100%'
          }}
        >

     {  
          reviewEventReducer?.editing_cycles_list[0]?.internal_revisions?.length > 0 && reviewEventReducer?.selected_video_logs_list?.length > 0 ? <>
             <Typography sx={{fontSize:{xs:'16px',lg:'20px',xl:'24px'}, ml:1.5, mb:1}}>Internal Feedback</Typography> 
          </> :  reviewEventReducer?.editing_cycles_list[0]?.revision !== null ? <>
             <Typography sx={{fontSize:{xs:'16px',lg:'20px',xl:'24px'}, ml:1.5, mb:1}}>Customer Feedback</Typography> 
          </> : <>
              <Typography sx={{fontSize:{xs:'16px',lg:'20px',xl:'24px'}, ml:1.5, mb:1}}>Checklist </Typography> 
          </>
          }
           
           {/* <Typography sx={{fontSize:{xs:'16px',lg:'20px',xl:'24px'}, ml:1.5, mb:1}}>Checklist </Typography>  */}

           <Box sx={{display:'flex', flexDirection:'column', height:'80%', overflowY:'scroll'}}>


           {
            reviewEventReducer?.editing_cycles_list[0]?.internal_revisions?.length > 0 && reviewEventReducer?.selected_video_logs_list?.length > 0 ? <>
          <Box sx={{display:'flex', flexDirection:'column', height:'100%', justifyContent:'space-between', paddingX:2}}>
                  <Box sx={{display:'flex', flexDirection:'column', height:'90%', maxHeight:'90%', overflowY:'scroll'}}>
                  {    reviewEventReducer?.selected_video_logs_list?.map((log, index) => (
                       <Box mt={1}  sx={{display:'flex',  width:'100%', justifyContent: 'start'}}>
                         <RevisionLogNote   color={generateDarkColor(log, 'username')} userName={log.username} message = {log.message} timestamp={log.timestamp}/>
                       </Box>
   
                  ))
              
                  }
                  </Box>
                  <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <FormControlLabel
                     control={
                            <Checkbox 
                              checked={checklistChecked} 
                              onChange={(e) => setChecklistChecked(e.target.checked)} 
                              disabled={!videoFile || isLoading} 
                            />
                            }
                     label="I have adressed all items."
                  />
                  </Box>
                  </Box>
          </> :  reviewEventReducer?.editing_cycles_list[0]?.revision !== null ? <>
          <Box sx={{display:'flex', flexDirection:'column', height:'100%', justifyContent:'space-between', paddingX:2}}>
                  <Box sx={{display:'flex', flexDirection:'column', height:'90%', maxHeight:'90%', overflowY:'scroll'}}>
                  {    reviewEventReducer?.editing_cycles_list[0]?.revision?.logs?.map((log, index) => (
                       <Box mt={1}  sx={{display:'flex',  width:'100%', justifyContent: 'start'}}>
                         <RevisionLogNote   color={generateDarkColor(log, 'username')} userName={log.username} message = {log.message} timestamp={log.timestamp}/>
                       </Box>
   
                  ))
              
                  }
                  </Box>
                  <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <FormControlLabel
                     control={
                            <Checkbox 
                              checked={checklistChecked} 
                              onChange={(e) => setChecklistChecked(e.target.checked)} 
                              disabled={!videoFile || isLoading} 
                            />
                            }
                     label="I have adressed all items."
                  />
                  </Box>
                  </Box>
          </> : stepList.map((label, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 1,
              }}
            >
              <Checkbox
                checked={checkedItems[index] || false}
                onChange={() => handleCheckboxChange(index)}
                disabled={!videoFile || isLoading} // Disable when no video is selected
              />
              <Typography>{label}</Typography>
            </Box>
          ))  
          }

         {/* {
          (reviewEventReducer?.editing_cycles_list[reviewEventReducer?.editing_cycles_list?.length - 1]?.version == 1 && reviewEventReducer?.internal_revisions_list?.length == 0 ) || (reviewEventReducer?.editing_cycles_list[reviewEventReducer?.editing_cycles_list?.length - 1]?.version == 1 && reviewEventReducer?.current_internal_revision?.version == 1 ) || (!reviewEventReducer?.selected_video_logs_list) ?  stepList.map((label, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 1,
              }}
            >
              <Checkbox
                checked={checkedItems[index] || false}
                onChange={() => handleCheckboxChange(index)}
                disabled={!videoFile || isLoading} // Disable when no video is selected
              />
              <Typography>{label}</Typography>
            </Box>
          ))  : <Box sx={{display:'flex', flexDirection:'column', height:'100%', justifyContent:'space-between', paddingX:2}}>
                  <Box sx={{display:'flex', flexDirection:'column', height:'90%', maxHeight:'90%', overflowY:'scroll'}}>
                  {    reviewEventReducer?.selected_video_logs_list?.map((log, index) => (
                       <Box mt={1}  sx={{display:'flex',  width:'100%', justifyContent: 'start'}}>
                         <RevisionLogNote   color={generateDarkColor(log, 'username')} userName={log.username} message = {log.message} timestamp={log.timestamp}/>
                       </Box>
   
                  ))
              
                  }
                  </Box>
                  <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <FormControlLabel
                     control={
                            <Checkbox 
                              checked={checklistChecked} 
                              onChange={(e) => setChecklistChecked(e.target.checked)} 
                              disabled={!videoFile || isLoading} 
                            />
                            }
                     label="I have adressed all items."
                  />
                  </Box>
                  </Box>
          } */}
         
         
         </Box>
         
          
                 
                  { !!videoFile && <Button
                    type="button"
                    disabled={( (( reviewEventReducer?.editing_cycles_list[0]?.internal_revisions?.length > 0 && reviewEventReducer?.selected_video_logs_list?.length > 0 ) || reviewEventReducer?.editing_cycles_list[0]?.revision !== null)  ?   !checklistChecked : !allChecked)  || isLoading }
                    onClick={handleProceed}
                    color='secondary'
                    variant="contained"
                    style={{
                      cursor: "pointer",
                      borderRadius: "10px",
                      border: "none",
                      fontSize: "20px",
                      fontWeight: 700,
                      padding: "5px",
                      fontFamily: 'Rubik'
                      
                    }}
                    endIcon={<UploadIcon/>}
                    sx={{ boxShadow: 3, width: '100%', minWidth: "100px", mt: 2, textTransform: 'none' }}
                  >
                    Upload
                  </Button>}
                   <Box sx={{visibility: !!videoFile && 'hidden'}}>

                        <MediaFilesDropzone
                         flex='row'
                         isDisabled={
                             isLoading || !!videoFile
                           }
                         files={files}
                         setFiles={setFiles}
                         setUploadStatus={setUploadStatus}
                         setProgress={setProgress}
                         setRequestController={setRequestController}
                         height={{xs: '90px',sm:'85px',md:'85px',lg:'105px', xl:'150px'}}
                         setEnableFileUpload={setEnableFileUpload}
                         button
                         setVideoFile={setVideoFile}
                         onProceedClick={onProceedClick}
                       />
                   </Box>
                   
                
             

        </Box>
      </Box>}
    </Box>
  );
};

export default UploadVideoChecklist;
